import { GetterTree } from "vuex";

import { RootState } from "@/store";

import { State } from "./state";

export type Getters = {
  partner(state: State): any;
  company(state: State): any;
  site(state: State): any;
  group(state: State): any;
  user(state: State): any;
  loggedInUser(state: State): any;
  mainUser(state: State): any;
};

export const getters: GetterTree<State, RootState> & Getters = {
  partner: state => state.partner,
  company: state => state.company,
  user: state => state.company,
  mainUser: state => state.user,
  loggedInUser: state => {
    const user: any = {};
    state.user.forEach(item => {
      user[item.type] = item.value;
    });

    return user;
  },
  site: state => state.site,
  group: state => state.group,
};
